__turbopack_context__.v({
  "className": "vV8Jla_className",
  "variable": "vV8Jla_variable",
});
